module.exports = __webpack_public_path__ + "img/jack.d5e862fe.jpg";